import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function Outsourcing() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist py-24 sm:py-32" aria-labelledby="outsourcing-heading" data-id="element-195" data-mp="3ccexd86yagu5">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-196" data-mp="3haq6thtc2pbu">
        <Reveal data-id="element-197" data-mp="3h83znjacubu5">
          <div className="mx-auto max-w-[760px] text-center" data-id="element-198" data-mp="2jmzjmanwi9uj">
            <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-199" data-mp="2joj0o3hdsoxd">
              {t.outsourcing.eyebrow}
            </p>
            <h2 id="outsourcing-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[46px]" data-id="element-200" data-mp="2tkdpjgc77g8l">
              {t.outsourcing.heading}
            </h2>
            <p className="mt-6 text-[17px] leading-relaxed text-ink/60" data-id="element-201" data-mp="2ydf7xybm5xwx">{t.outsourcing.subtitle}</p>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-202" data-mp="25uro0m8csoxf">
          <div className="mt-14 overflow-hidden rounded-4xl border border-ink/[0.07] bg-white shadow-lift" data-id="element-203" data-mp="25u0448o4cfmz">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/5c6a9762-4fe0-44c0-a56f-6ce0eb78f1fc.jpg" alt={t.outsourcing.imageAlt} className="w-full object-cover" data-id="element-204" data-mp="dx2g5czoz15m" />
          </div>
        </Reveal>

        <ul className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-205" data-mp="45o8ghxl6v1e">
          {t.outsourcing.items.map((item, i) => <Reveal as="li" key={item.title} delay={i * 0.06} data-id="element-206" data-mp="4cpuwd4ra2p" data-mpi={i}>
              <div className="h-full rounded-3xl border border-ink/[0.07] bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-brand/25 hover:shadow-lift" data-id="element-207" data-mp="3rd9w4lhk6e93">
                <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-brand/10" data-id="element-208" data-mp="3hf2dly7mfo4z">
                  <CheckIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-209" data-mp="3de0nc6vommf5" />
                </span>
                <h3 className="mt-5 text-[16px] font-semibold tracking-tight text-ink" data-id="element-210" data-mp="1flmjusg8lt5s">{item.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-ink/60" data-id="element-211" data-mp="1bluc2hyo3r1h">{item.body}</p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}